/**
 * Хелпер для вывода номера телефона в скрытом формате
 * @param phoneNumber телефон в формате '79198991234' | '+7 (999) 999-12-34'
 * @return +7 ··· ··· 12-34
 * */
export const preparePhone = (phoneNumber: string) => {
    const cleaned = phoneNumber.replace(/\D/g, '');
    const match = cleaned.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (match) {
        return `+${match[1]} ··· ··· ${match[4]}-${match[5]}`;
    }

    return phoneNumber;
};
